import React from 'react';
import {Box} from "@mui/material"
import {alpha} from "@mui/material/styles"
import {Check, Close} from "@mui/icons-material"
import {RESULT_COLORS} from "../../library/ClassColors"

function MatchBadge({correct}: {correct: boolean}) {
    const color = correct ? RESULT_COLORS.correct : RESULT_COLORS.incorrect
    return (
        <Box sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 22,
            height: 22,
            borderRadius: "50%",
            color: color,
            bgcolor: alpha(color, 0.14),
        }}>
            {correct ? <Check sx={{fontSize: 15}}/> : <Close sx={{fontSize: 15}}/>}
        </Box>
    )
}

export default MatchBadge;
